import React from 'react';
import {Link} from 'react-router-dom';
import {Icon} from '../../../../uiToolkit/Icon/Icon';

interface Props {
  icon: any;
  title: string;
  slug: string;
  route: string;
  activeIcon: any;
  activeRoute: string;
  userPermissions: string[];
  permission?: string;
  collapsed: boolean;
  newTab?: boolean;
}

const NavListItem = React.memo(
  ({
    title,
    route,
    icon,
    slug,
    activeRoute,
    userPermissions,
    permission,
    collapsed,
    newTab,
  }: Props) => {
    const checkPermission = (permission: string) => {
      return userPermissions.find(up => up === permission);
    };

    if (permission && !checkPermission(permission)) {
      return <div />;
    }

    return (
      <div
        className={`NavListItemContainer ${
          activeRoute.includes(route) ? 'activeRouteLink' : ''
        } ${collapsed ? 'NavListItemCollapsed' : ''}`}>
        <Link
          to={route}
          target={newTab ? '_blank' : ''}
          className={`MainRouteLink ${slug} ${
            collapsed ? 'MainRouteLinkCollapsed' : ''
          }`}>
          <Icon name={icon} className="NavIcon" />
          {!collapsed && (
            <span className={activeRoute.includes(route) ? 'Active' : ''}>
              {title}
            </span>
          )}
        </Link>
      </div>
    );
  },
);

export default NavListItem;
